import { lazyRouteComponent } from '@tanstack/react-router';
import { Bug } from 'lucide-react';
import type { WebModule } from '../web-module.ts';

/** Módulo Defeitos nas telas. Os textos ficam em `defects.*`. */
export const webModule: WebModule = {
  id: 'defects',
  areas: [
    {
      id: 'defects',
      key: 'defects.area',
      icon: Bug,
      groups: [
        {
          key: null,
          items: [
            {
              to: '/defects',
              key: 'defects.nav.list',
              icon: Bug,
              permission: ['defects.defect.read', 'defects.defect.manage'],
            },
          ],
        },
      ],
    },
  ],
  routes: [
    {
      path: '/defects',
      component: lazyRouteComponent(() => import('./DefectsPage.tsx'), 'DefectsPage'),
    },
  ],
  permissionAreas: [
    {
      id: 'defects',
      key: 'defects.area',
      processes: [
        {
          id: 'defects',
          key: 'defects.process',
          permissions: ['defects.defect.read', 'defects.defect.manage'],
        },
      ],
    },
  ],
};
